<div id="mainmenuelem" class="nav" [ngClass]="{'horizontal':layout === 'horizontal', 'vertical':layout === 'vertical'}">

  <!-- Vertical Navigation Layout -->
  @if (layout === 'vertical') {
    <div class="navbar-content">
      @for (item of navigation; track item) {
        @if (item.type === 'group') {
          <fuse-nav-vertical-group
            [ngClass]="'wrapper-menu-group-' + item.id + ' ' + (item.class?.join(' ') || '')"
            [item]="item"
          ></fuse-nav-vertical-group>
        }
        @if (item.type === 'collapse') {
          <fuse-nav-vertical-collapsable
            [ngClass]="'wrapper-menu-collapsable-' + item.id + ' ' + (item.class?.join(' ') || '')"
            [item]="item"
          ></fuse-nav-vertical-collapsable>
        }
        @if (item.type === 'item') {
          <fuse-nav-vertical-item
            [ngClass]="'wrapper-menu-item-' + item.id + ' ' + (item.class?.join(' ') || '')"
            [item]="item"
          ></fuse-nav-vertical-item>
        }
      }
    </div>
    <div class="menu-link-block">
      @for (item of navigation; track item) {
        @if (item.type==='link') {
          @if (isInternalUrl(item)) {
            <a class="menu-link" [routerLink]="[item.url]">
              @if (item.icon) {
                <mat-icon class="nav-link-icon svg-icon" [svgIcon]="item.icon"></mat-icon>
              }
              <span class="nav-link-title">{{item.translate | translate }}</span>
            </a>
          }
          @if (!isInternalUrl(item)) {
            <a class="menu-link" href="{{item.url}}" target="_blank">
              @if (item.icon) {
                <mat-icon class="nav-link-icon svg-icon" [svgIcon]="item.icon"></mat-icon>
              }
              <span class="nav-link-title">{{item.translate | translate }}</span>
            </a>
          }
        }
      }
    </div>
  }
  <!-- / Vertical Navigation Layout -->

  <!-- Horizontal Navigation Layout -->
  @if (layout === 'horizontal') {
    @for (item of navigation; track item) {
      @if (item.type==='group') {
        <fuse-nav-horizontal-collapsable [item]="item"></fuse-nav-horizontal-collapsable>
      }
      @if (item.type==='collapse') {
        <fuse-nav-horizontal-collapsable [item]="item">
        </fuse-nav-horizontal-collapsable>
      }
      @if (item.type==='item') {
        <fuse-nav-horizontal-item [item]="item"></fuse-nav-horizontal-item>
      }
      @if (item.type==='link') {
        <a class="menu-link" [routerLink]="[item.url]">
          @if (item.icon) {
            <mat-icon class="nav-link-icon svg-icon" [svgIcon]="item.icon"></mat-icon>
          }
          <span class="nav-link-title">{{item.translate | translate }}</span>
        </a>
      }
    }
  }
  <!-- / Horizontal Navigation Layout -->

</div>